var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"mr-3",attrs:{"tile":"","size":"40"}},[_c('span',{staticClass:"id-icon"},[_vm._v("id")])])
}
var staticRenderFns = []

export { render, staticRenderFns }